import SHA256 from 'sha.js';
import { login } from '@bonanza-social/auth';
import { startListening, trackEvent } from '@bonanza-social/toolkit/state';
import { getAccount } from '@bonanza-social/account/state';
import { logInfo } from '@bonanza-social/toolkit/logging';
import {
  fetchRegistrationConfig,
  submitSocialRegistrationForm,
} from '@bonanza-social/registration/state';
import { initAnalytics } from './analytics.utils';
import { jwtDecode } from 'jwt-decode';

const analytics = initAnalytics();

if (analytics && !__DEV__) {
  startListening({
    actionCreator: login.fulfilled,
    effect: (action, { dispatch }) => {
      const profile = jwtDecode(action.payload.id_token);

      if ((profile as any).sub) {
        analytics.setUserId((profile as any).sub);

        dispatch(
          trackEvent({
            name: 'login',
            params: {
              userId: (profile as any).sub,
            },
          }),
        );
      }
    },
  });

  startListening({
    actionCreator: getAccount.fulfilled,
    effect: (action) => {
      analytics.setUserProperties({
        accountStatus: action.payload.status,
        isTestAccount: String(action.payload.isTestAccount),
      });
    },
  });

  startListening({
    actionCreator: trackEvent,
    effect: (action) => {
      analytics.logEvent(action.payload.name, action.payload.params);
    },
  });

  startListening({
    actionCreator: fetchRegistrationConfig.fulfilled,
    effect: (action) => {
      analytics.setUserProperties({
        registrationConfigId: action.payload.data.id,
      });
    },
  });

  startListening({
    actionCreator: submitSocialRegistrationForm.fulfilled,
    effect: (action, { dispatch }) => {
      const params = {
        email: SHA256('sha256')
          .update(action.payload.formData.email)
          .digest('hex'),
        accountId: SHA256('sha256')
          .update(action.payload.account.accountId.toString())
          .digest('hex'),
      };
      dispatch(
        trackEvent({
          name: 'sign_up_completed',
          params,
        }),
      );
    },
  });

  const blacklistedActions = [
    'persist',
    'tracking',
    'activity',
    'jackpots',
    'globalContext',
    'globalAlert/fetch/pending',
    'globalAlert/fetch/fulfilled',
  ];

  type MetaArgType = number | string | boolean | undefined;
  type MetaType = { arg?: MetaArgType };

  startListening({
    predicate: ({ type }) =>
      !blacklistedActions.find((action) => type.match(action)),
    effect: (action, { dispatch }) => {
      const meta = action.meta as MetaType; // TODO: Check for better solution

      dispatch(
        trackEvent({
          name: 'state_event',
          params: {
            stateEventType: action.type,
            stateEventArg: (typeof meta?.arg).match('number|string|boolean')
              ? meta?.arg
              : '',
          },
        }),
      );
    },
  });

  if (__DEV__) {
    startListening({
      actionCreator: trackEvent,
      effect: (action) => {
        logInfo('Tracking', 'event', action.payload);
      },
    });
  }
}
